import React, { Component } from 'react';
//import _find from 'lodash/find'
import _without from 'lodash/without'


class renderFieldRadio extends Component {

  onChange(event) {
    const { input, itemValue } = this.props;
    var oldValues = input.value || [];
    var newValues = _without(oldValues, itemValue); // remove value
    if (event.target.checked) { // was checked
      newValues = oldValues.concat(itemValue);
    }
    input.onChange(newValues);
  }

  render() {

    const { input, itemValue,label,meta: { touched, error } } = this.props;
     
    return (
       <div className="form-group">
           <div className="checkbox checkboxLista">  
             <label>
              <input
           //   {...input}
                  type="checkbox"
                  checked={input.value.indexOf(itemValue) >= 0}
                  onChange={this.onChange.bind(this)}
               />
            {label}  {touched && error && <span className="text-danger">{error}</span>}
               </label>
           </div>
         </div> 
    );
  }
}

export default renderFieldRadio;


// import React from 'react';





// const renderFieldRadio = ({ input,label, type,value,meta: { touched, error } }) => (
//   <div className="form-group">
//     <div className="checkbox">  
//     {console.log(input)}
//       <label>
//           <input 
//               {...input} 
//               type   = "checkbox"
//               onBlur = {() => input.onBlur()}
//               value  = {input.value || []}
//               name   = {input.name}
//               value  = {value} />
//               {label}
//               {touched && error && <span className="text-danger"> { error }</span>}
//         </label>
//     </div>

//   </div>
// );

// export default renderFieldRadio;



// WEBPACK FOOTER //
// ./src/container/renderFieldCheckBox.js